import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import Add from './add';

const styles = {
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class FullScreenDialog extends React.Component {

  state = {}

  componentDidUpdate(props) {
    if (props.id == this.props.id) {
      return;
    }
    let data = this.props.id.split('->');
    this.setState({
      id: data[0],
      name: data[1]
    });
  }

  handleItems= (data, type) => {
    if (type == 'menu') {
      this.setState({
        items: data
      })
    }
  }

  handleSubmit = (data) => {
    if (this.props.editmenucontrol == 'none') {
      alert('Access is Denied!!!');
      return;
    }
    this.props.handleinsert(this.state.items, this.state.items2);
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          fullScreen
          open={this.props.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>
                {this.state.name}
              </Typography>
              <Button color="inherit" onClick={this.handleSubmit}>
                Submit
              </Button>
            </Toolbar>
          </AppBar>
          <Add id={this.state.id} executives={this.props.executives}
              updatedata={this.handleItems}/>
        </Dialog>
      </div>
    );
  }
}

FullScreenDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FullScreenDialog);
